export const BoatsMap = () => null
